var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h-3 w-3"},[(_vm.pnl > 0)?_c('i',{domProps:{"innerHTML":_vm._s(_vm.$icons.play_green)}}):(_vm.pnl < 0)?_c('i',{domProps:{"innerHTML":_vm._s(_vm.$icons.play_red)}}):_c('i',{staticClass:"w-3 h-3 rounded-full bg-gray-500"})])
}
var staticRenderFns = []

export { render, staticRenderFns }